import {Form} from '@deere/ux.uxframe-react';
import {Table as UxTable} from '@deere/ux.uxframe-react'
import {getAnswerLabel, getTranslation} from '../../utils/utils'

export default function TableSectionReview({question,answers}){
    return(
            <div>
                <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(question,'text')}</Form.Label>
                </Form.Group>
                <UxTable size="sm" borderless>
                    <tbody>
                        <tr>
                            {
                                question.dependentQuestions.map((q,index) =>{
                                     return <td key={index}>
                                        <Form.Group>
                                            <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                                            <h6>{getAnswerLabel(q,answers)}</h6>
                                        </Form.Group>
                                        </td>
                                })
                            } 
                        </tr> 
                    </tbody>
                </UxTable>
            </div>
    )
}